import React from 'react';
import Footer from '../../components/footer';
import { AllFormations } from '../../components/formations';
import Navbar from '../../components/navbar';

function Formations (){
    return(        
        <body>
        <Navbar/>
        <hr className='hr-min'/>
        <AllFormations/>
        <Footer/>
        </body>
    )
}
export default Formations;